import {
  getObject,
  getList,
} from "@surya-digital/leo-ts-types";
import { SingleSelectGraphTypeV1 } from "./singleSelectGraphTypeV1";
import { SingleSelectWithProportionGraphTypeV1 } from "./singleSelectWithProportionGraphTypeV1";
import { SingleSelectNpsGraphTypeV1 } from "./singleSelectNpsGraphTypeV1";
import { MultiSelectGraphTypeV1 } from "./multiSelectGraphTypeV1";
import { RankingGraphTypeV1 } from "./rankingGraphTypeV1";
import { OpenEndedGraphTypeV1 } from "./openEndedGraphTypeV1";
import { GridElementGraphTypeV1, GridElementGraphTypeV1DTO, GridElementGraphTypeV1Enums } from "./gridElementGraphTypeV1";


export namespace GroupChildGraphTypeV1 {
  export interface SingleSelectDTO {
    case: string;
    singleSelectGraphType: SingleSelectGraphTypeV1.SingleSelectGraphTypeV1DTO;
  }
  
  export class SingleSelect {
    readonly isGroupChildGraphTypeV1SingleSelect: boolean = true;
  
    readonly singleSelectGraphType: SingleSelectGraphTypeV1.SingleSelectGraphTypeV1;
  
  
    constructor(
    singleSelectGraphType: SingleSelectGraphTypeV1.SingleSelectGraphTypeV1
    ) {
      this.singleSelectGraphType = singleSelectGraphType;
    }
  
    static fromDTO(dto: SingleSelectDTO): SingleSelect {
      const singleSelectGraphType = SingleSelectGraphTypeV1.fromDTO(getObject(dto, "singleSelectGraphType", InvalidGroupChildGraphTypeV1SingleSelectSingleSelectGraphTypeError));
      return new SingleSelect(
        singleSelectGraphType
      );
    }
  
    toDTO(): SingleSelectDTO {
      const dto: SingleSelectDTO = {
        case: "SINGLE_SELECT",
          singleSelectGraphType: SingleSelectGraphTypeV1.toDTO(this.singleSelectGraphType)
      };
      return dto;
    }
    }
  
  SingleSelect.prototype.toString = function toString(): string {
    return `GroupChildGraphTypeV1.SINGLE_SELECT(singleSelectGraphType='${this.singleSelectGraphType}')`;
  };
  
  export interface SingleSelectWithProportionDTO {
    case: string;
    singleSelectWithProportionGraphType: SingleSelectWithProportionGraphTypeV1.SingleSelectWithProportionGraphTypeV1DTO;
  }
  
  export class SingleSelectWithProportion {
    readonly isGroupChildGraphTypeV1SingleSelectWithProportion: boolean = true;
  
    readonly singleSelectWithProportionGraphType: SingleSelectWithProportionGraphTypeV1.SingleSelectWithProportionGraphTypeV1;
  
  
    constructor(
    singleSelectWithProportionGraphType: SingleSelectWithProportionGraphTypeV1.SingleSelectWithProportionGraphTypeV1
    ) {
      this.singleSelectWithProportionGraphType = singleSelectWithProportionGraphType;
    }
  
    static fromDTO(dto: SingleSelectWithProportionDTO): SingleSelectWithProportion {
      const singleSelectWithProportionGraphType = SingleSelectWithProportionGraphTypeV1.fromDTO(getObject(dto, "singleSelectWithProportionGraphType", InvalidGroupChildGraphTypeV1SingleSelectWithProportionSingleSelectWithProportionGraphTypeError));
      return new SingleSelectWithProportion(
        singleSelectWithProportionGraphType
      );
    }
  
    toDTO(): SingleSelectWithProportionDTO {
      const dto: SingleSelectWithProportionDTO = {
        case: "SINGLE_SELECT_WITH_PROPORTION",
          singleSelectWithProportionGraphType: SingleSelectWithProportionGraphTypeV1.toDTO(this.singleSelectWithProportionGraphType)
      };
      return dto;
    }
    }
  
  SingleSelectWithProportion.prototype.toString = function toString(): string {
    return `GroupChildGraphTypeV1.SINGLE_SELECT_WITH_PROPORTION(singleSelectWithProportionGraphType='${this.singleSelectWithProportionGraphType}')`;
  };
  
  export interface SingleSelectNpsDTO {
    case: string;
    singleSelectNpsGraphType: SingleSelectNpsGraphTypeV1.SingleSelectNpsGraphTypeV1DTO;
  }
  
  export class SingleSelectNps {
    readonly isGroupChildGraphTypeV1SingleSelectNps: boolean = true;
  
    readonly singleSelectNpsGraphType: SingleSelectNpsGraphTypeV1.SingleSelectNpsGraphTypeV1;
  
  
    constructor(
    singleSelectNpsGraphType: SingleSelectNpsGraphTypeV1.SingleSelectNpsGraphTypeV1
    ) {
      this.singleSelectNpsGraphType = singleSelectNpsGraphType;
    }
  
    static fromDTO(dto: SingleSelectNpsDTO): SingleSelectNps {
      const singleSelectNpsGraphType = SingleSelectNpsGraphTypeV1.fromDTO(getObject(dto, "singleSelectNpsGraphType", InvalidGroupChildGraphTypeV1SingleSelectNpsSingleSelectNpsGraphTypeError));
      return new SingleSelectNps(
        singleSelectNpsGraphType
      );
    }
  
    toDTO(): SingleSelectNpsDTO {
      const dto: SingleSelectNpsDTO = {
        case: "SINGLE_SELECT_NPS",
          singleSelectNpsGraphType: SingleSelectNpsGraphTypeV1.toDTO(this.singleSelectNpsGraphType)
      };
      return dto;
    }
    }
  
  SingleSelectNps.prototype.toString = function toString(): string {
    return `GroupChildGraphTypeV1.SINGLE_SELECT_NPS(singleSelectNpsGraphType='${this.singleSelectNpsGraphType}')`;
  };
  
  export interface MultiSelectDTO {
    case: string;
    multiSelectGraphType: MultiSelectGraphTypeV1.MultiSelectGraphTypeV1DTO;
  }
  
  export class MultiSelect {
    readonly isGroupChildGraphTypeV1MultiSelect: boolean = true;
  
    readonly multiSelectGraphType: MultiSelectGraphTypeV1.MultiSelectGraphTypeV1;
  
  
    constructor(
    multiSelectGraphType: MultiSelectGraphTypeV1.MultiSelectGraphTypeV1
    ) {
      this.multiSelectGraphType = multiSelectGraphType;
    }
  
    static fromDTO(dto: MultiSelectDTO): MultiSelect {
      const multiSelectGraphType = MultiSelectGraphTypeV1.fromDTO(getObject(dto, "multiSelectGraphType", InvalidGroupChildGraphTypeV1MultiSelectMultiSelectGraphTypeError));
      return new MultiSelect(
        multiSelectGraphType
      );
    }
  
    toDTO(): MultiSelectDTO {
      const dto: MultiSelectDTO = {
        case: "MULTI_SELECT",
          multiSelectGraphType: MultiSelectGraphTypeV1.toDTO(this.multiSelectGraphType)
      };
      return dto;
    }
    }
  
  MultiSelect.prototype.toString = function toString(): string {
    return `GroupChildGraphTypeV1.MULTI_SELECT(multiSelectGraphType='${this.multiSelectGraphType}')`;
  };
  
  export interface RankingDTO {
    case: string;
    rankingGraphType: RankingGraphTypeV1.RankingGraphTypeV1DTO;
  }
  
  export class Ranking {
    readonly isGroupChildGraphTypeV1Ranking: boolean = true;
  
    readonly rankingGraphType: RankingGraphTypeV1.RankingGraphTypeV1;
  
  
    constructor(
    rankingGraphType: RankingGraphTypeV1.RankingGraphTypeV1
    ) {
      this.rankingGraphType = rankingGraphType;
    }
  
    static fromDTO(dto: RankingDTO): Ranking {
      const rankingGraphType = RankingGraphTypeV1.fromDTO(getObject(dto, "rankingGraphType", InvalidGroupChildGraphTypeV1RankingRankingGraphTypeError));
      return new Ranking(
        rankingGraphType
      );
    }
  
    toDTO(): RankingDTO {
      const dto: RankingDTO = {
        case: "RANKING",
          rankingGraphType: RankingGraphTypeV1.toDTO(this.rankingGraphType)
      };
      return dto;
    }
    }
  
  Ranking.prototype.toString = function toString(): string {
    return `GroupChildGraphTypeV1.RANKING(rankingGraphType='${this.rankingGraphType}')`;
  };
  
  export interface OpenEndedDTO {
    case: string;
    openEndedGraphType: OpenEndedGraphTypeV1.OpenEndedGraphTypeV1DTO;
  }
  
  export class OpenEnded {
    readonly isGroupChildGraphTypeV1OpenEnded: boolean = true;
  
    readonly openEndedGraphType: OpenEndedGraphTypeV1.OpenEndedGraphTypeV1;
  
  
    constructor(
    openEndedGraphType: OpenEndedGraphTypeV1.OpenEndedGraphTypeV1
    ) {
      this.openEndedGraphType = openEndedGraphType;
    }
  
    static fromDTO(dto: OpenEndedDTO): OpenEnded {
      const openEndedGraphType = OpenEndedGraphTypeV1.fromDTO(getObject(dto, "openEndedGraphType", InvalidGroupChildGraphTypeV1OpenEndedOpenEndedGraphTypeError));
      return new OpenEnded(
        openEndedGraphType
      );
    }
  
    toDTO(): OpenEndedDTO {
      const dto: OpenEndedDTO = {
        case: "OPEN_ENDED",
          openEndedGraphType: OpenEndedGraphTypeV1.toDTO(this.openEndedGraphType)
      };
      return dto;
    }
    }
  
  OpenEnded.prototype.toString = function toString(): string {
    return `GroupChildGraphTypeV1.OPEN_ENDED(openEndedGraphType='${this.openEndedGraphType}')`;
  };
  
  export interface GridDTO {
    case: string;
    gridElementGraphTypes: GridElementGraphTypeV1DTO[];
  }
  
  export class Grid {
    readonly isGroupChildGraphTypeV1Grid: boolean = true;
  
    readonly gridElementGraphTypes: GridElementGraphTypeV1[];
  
  
    constructor(
    gridElementGraphTypes: GridElementGraphTypeV1[]
    ) {
      this.gridElementGraphTypes = gridElementGraphTypes;
    }
  
    static fromDTO(dto: GridDTO): Grid {
      const gridElementGraphTypes = getList<GridElementGraphTypeV1DTO, GridElementGraphTypeV1>(
        dto,
        "gridElementGraphTypes",
        GridElementGraphTypeV1.fromDTO,
        InvalidGroupChildGraphTypeV1GridGridElementGraphTypesError
      );
      return new Grid(
        gridElementGraphTypes
      );
    }
  
    toDTO(): GridDTO {
      const dto: GridDTO = {
        case: "GRID",
          gridElementGraphTypes: this.gridElementGraphTypes.map((e: GridElementGraphTypeV1) => { return e.toDTO() })
      };
      return dto;
    }
    }
  
  Grid.prototype.toString = function toString(): string {
    return `GroupChildGraphTypeV1.GRID(gridElementGraphTypes='${this.gridElementGraphTypes}')`;
  };
  

  export type GroupChildGraphTypeV1 = SingleSelect | SingleSelectWithProportion | SingleSelectNps | MultiSelect | Ranking | OpenEnded | Grid;

  export type GroupChildGraphTypeV1DTO = SingleSelectDTO | SingleSelectWithProportionDTO | SingleSelectNpsDTO | MultiSelectDTO | RankingDTO | OpenEndedDTO | GridDTO;

  export const fromDTO = (dto: GroupChildGraphTypeV1DTO): GroupChildGraphTypeV1 => {
    switch (dto.case) {
      case "SINGLE_SELECT":
          return SingleSelect.fromDTO(dto as SingleSelectDTO);
      case "SINGLE_SELECT_WITH_PROPORTION":
          return SingleSelectWithProportion.fromDTO(dto as SingleSelectWithProportionDTO);
      case "SINGLE_SELECT_NPS":
          return SingleSelectNps.fromDTO(dto as SingleSelectNpsDTO);
      case "MULTI_SELECT":
          return MultiSelect.fromDTO(dto as MultiSelectDTO);
      case "RANKING":
          return Ranking.fromDTO(dto as RankingDTO);
      case "OPEN_ENDED":
          return OpenEnded.fromDTO(dto as OpenEndedDTO);
      case "GRID":
          return Grid.fromDTO(dto as GridDTO);
      default:
        throw new InvalidGroupChildGraphTypeV1Error(
            `Case ${dto.case} is not valid case of GroupChildGraphTypeV1.`
        );
    }
  };
}

export class InvalidGroupChildGraphTypeV1Error extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGroupChildGraphTypeV1Error";
  }
}
export class InvalidGroupChildGraphTypeV1SingleSelectError extends InvalidGroupChildGraphTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGroupChildGraphTypeV1SingleSelectError";
  }
}

export class InvalidGroupChildGraphTypeV1SingleSelectSingleSelectGraphTypeError extends InvalidGroupChildGraphTypeV1SingleSelectError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGroupChildGraphTypeV1SingleSelectSingleSelectGraphTypeError";
  }
}

export class InvalidGroupChildGraphTypeV1SingleSelectWithProportionError extends InvalidGroupChildGraphTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGroupChildGraphTypeV1SingleSelectWithProportionError";
  }
}

export class InvalidGroupChildGraphTypeV1SingleSelectWithProportionSingleSelectWithProportionGraphTypeError extends InvalidGroupChildGraphTypeV1SingleSelectWithProportionError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGroupChildGraphTypeV1SingleSelectWithProportionSingleSelectWithProportionGraphTypeError";
  }
}

export class InvalidGroupChildGraphTypeV1SingleSelectNpsError extends InvalidGroupChildGraphTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGroupChildGraphTypeV1SingleSelectNpsError";
  }
}

export class InvalidGroupChildGraphTypeV1SingleSelectNpsSingleSelectNpsGraphTypeError extends InvalidGroupChildGraphTypeV1SingleSelectNpsError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGroupChildGraphTypeV1SingleSelectNpsSingleSelectNpsGraphTypeError";
  }
}

export class InvalidGroupChildGraphTypeV1MultiSelectError extends InvalidGroupChildGraphTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGroupChildGraphTypeV1MultiSelectError";
  }
}

export class InvalidGroupChildGraphTypeV1MultiSelectMultiSelectGraphTypeError extends InvalidGroupChildGraphTypeV1MultiSelectError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGroupChildGraphTypeV1MultiSelectMultiSelectGraphTypeError";
  }
}

export class InvalidGroupChildGraphTypeV1RankingError extends InvalidGroupChildGraphTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGroupChildGraphTypeV1RankingError";
  }
}

export class InvalidGroupChildGraphTypeV1RankingRankingGraphTypeError extends InvalidGroupChildGraphTypeV1RankingError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGroupChildGraphTypeV1RankingRankingGraphTypeError";
  }
}

export class InvalidGroupChildGraphTypeV1OpenEndedError extends InvalidGroupChildGraphTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGroupChildGraphTypeV1OpenEndedError";
  }
}

export class InvalidGroupChildGraphTypeV1OpenEndedOpenEndedGraphTypeError extends InvalidGroupChildGraphTypeV1OpenEndedError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGroupChildGraphTypeV1OpenEndedOpenEndedGraphTypeError";
  }
}

export class InvalidGroupChildGraphTypeV1GridError extends InvalidGroupChildGraphTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGroupChildGraphTypeV1GridError";
  }
}

export class InvalidGroupChildGraphTypeV1GridGridElementGraphTypesError extends InvalidGroupChildGraphTypeV1GridError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGroupChildGraphTypeV1GridGridElementGraphTypesError";
  }
}
